import React from 'react';
import SectionHeader from '../common/SectionHeader';

import TeamImage from '../assets/home/team.jpeg';
import { useI18n } from '../i18n/I18nContext';
import { routeIds } from '../i18n/routes';

function Team() {
  const { pathFor, t } = useI18n();

  return (
    <section id="equipe" className="relative bg-accent min-h-[40.125rem] overflow-x-clip py-[5rem] px-10">
      <div className="max-w-[1200px] mx-auto z-20">
        <img src={TeamImage} alt={t("home.team.title")} className="hidden sm:block absolute w-[600px] aspect-square left-1/2 top-[-40px] transform translate-x-[40px] rounded-tl-[80px] rounded-tr-[80px] rounded-br-[80px] z-30" />
        <div data-reveal className="flex flex-col w-full sm:w-1/2 sm:pr-5">
          <SectionHeader title={t("home.team.title")} subtitle={t("home.team.subtitle")} style="dark" />
          <div className="text-white text-base text-left pt-[2.5rem] pb-[4.375rem]" dangerouslySetInnerHTML={{__html: t("home.team.text")}}></div>
          <a className="motion-link text-lg ml-auto font-bold text-white underline transition duration-300 hover:opacity-50" href={pathFor(routeIds.team)}>{">"} {t("expertise.common.learnMore")}</a>
        </div>
      </div>
    </section>
  );
}

export default Team;
